<template>
  <div class="main">
    <div class="header">
      <div v-show="status === 'resolve'" class="result-title">
        <img src="../../../assets/icons/success.png" class="result-title-img" />
        <span class="result-title-tip" v-if="isOffLine">{{ $t('您已选择线下支付，支付成功后订单状态将及时更新') }}</span>
        <span class="result-title-tip" v-if="!isOffLine">{{ $t('恭喜！您已支付成功！') }}</span>
        <span v-if="!isOffLine" class="result-online-tip"
          >{{ $t('提示：您可以通过e签宝官网在') }}<es-button type="text" @click="jumpToOrder">{{ $t('费用中心') }}</es-button
          >{{ $t('中查看相关订单及使用情况。') }}</span
        >
      </div>
      <div v-show="status === 'reject'" class="result-title">
        <img src="../../../assets/icons/buy_failed.svg" class="result-title-img" />
        <span class="result-title-tip">{{ $t('抱歉，支付失败！') }}</span>
        <span class="result-title-reason">{{ $t('失败原因：') }}{{ reason }}</span>
      </div>
      <div v-show="status === 'pending'" class="result-title">
        <spin class="result-title-img"></spin>
        <span class="result-title-tip">{{ $t('请稍等，支付确认中…') }}</span>
      </div>
    </div>

    <div class="body">
      <subTable :tableData="tableData"></subTable>
    </div>

    <div class="footer" v-if="isOffLine">
      <div class="top">
        <span>{{ $t('线下转账支付信息：') }}&nbsp;</span>
        <EButton :width="68" :height="28" v-clipboard:success="copySuccess" v-clipboard:copy="copyValue">{{ $t('复制') }}</EButton>
      </div>
      <div class="e-collapse-content">
        <ul>
          <li>
            <span>{{ $t('公司名称：') }}</span>
            <span>{{ $t('杭州天谷信息科技有限公司') }}</span>
          </li>
          <li>
            <span>{{ $t('税号：') }}</span>
            <span>913301087458306077</span>
          </li>
          <li>
            <span>{{ $t('地址：') }}</span>
            <span>{{ $t('浙江省杭州市西湖区西斗门路3号天堂软件园D幢19层') }}</span>
          </li>
          <li>
            <span>{{ $t('电话：') }}</span>
            <span>0571-88234700</span>
          </li>
          <li>
            <span>{{ $t('开户银行：') }}</span>
            <span>{{ $t('平安银行杭州高新支行') }}</span>
          </li>
          <li>
            <span>{{ $t('银行账号：') }}</span>
            <span>{{ transferInfo.bankAccountNo || '--' }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

export default {
  components: {
    spin: () => import('@/components/spin'),
    subTable: () => import('./components/subTable'),
    EButton: () => import('@/components/EButton.vue'),
  },
  data() {
    return {
      tableData: [],
      clock: null,
      status: '',
      reason: '',
      isOffLine: !this.$route.query.payOrderId,
      transferInfo: {},
      copyValue: '',
    }
  },
  methods: {
    copySuccess() {
      this.$message.success($t('支付信息已复制成功，直接操作粘贴即可。'))
    },
    jumpToOrder() {
      this.$router.push({ path: 'MyOrder' })
    },
    // 获取信息
    getInfo() {
      this.$ajax(this.$url.getPayInvitations(this.$route.query.invitationId), {}).then(res => {
        this.tableData = res.data.invitationOrder || []
      })
    },
    //
    getPayOrderStatus() {
      const oneMin = 1000
      this.clock = setInterval(() => {
        this.$ajax(this.$url.getPayOrderDetail(this.$route.query.payOrderId)).then(res => {
          if (res.data.status === 'PAY_SUCCESS') {
            this.status = 'resolve'
            clearInterval(this.clock)
          } else if (res.data.status === 'PAY_AUDITING' || res.data.status === 'PAY_PENDING') {
            this.status = 'pending'
          } else {
            const { status } = res.data
            if (status === 'PAY_OUT_TIME') {
              this.reason = $t('用户取消')
            }
            if (status === 'PAY_CANCEL') {
              this.reason = $t('超时取消')
            }
            if (status === 'PAY_ABEND') {
              this.reason = $t('异常终止')
            }

            this.status = 'reject'
            clearInterval(this.clock)
          }
        })
      }, oneMin)
    },
    // 获取转账信息
    getTransferInfo() {
      this.$ajax(this.$url.getTransferInfo(this.$route.query.invitationId), {}).then(res => {
        this.transferInfo = res.data || {}
        const bankAccountNo = res.data.bankAccountNo || '--'
        this.copyValue = `
          ${$t('公司名称：')}${$t('杭州天谷信息科技有限公司')}
          ${$t('税号：')}913301087458306077
          ${$t('地址：')}${$t('浙江省杭州市西湖区西斗门路3号天堂软件园D幢19层')}
          ${$t('电话：')}0571-88234700
          ${$t('开户银行：')}${$t('平安银行杭州高新支行')}
          ${$t('银行账号：')}${bankAccountNo}
        `
      })
    },
  },
  created() {
    this.getInfo()
    this.getTransferInfo()
    if (this.$route.query.payOrderId) {
      this.getPayOrderStatus()
    } else {
      this.status = 'resolve'
    }
  },
}
</script>
<style lang="less" scoped>
.main {
  width: 1200px;
  margin: 0 auto;
}
.header {
  text-align: center;
  padding-top: 120px;
  img {
    width: 44px;
    height: 44px;
  }
}
.result-title {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.result-title-tip {
  color: #333;
  font-size: 18px;
  margin: 18px 0 10px 0;
}
.result-online-tip {
  color: #999999;
  font-size: 14px;
  margin: 18px 0 10px 0;
}
.result-title-reason {
  margin-bottom: 20px;
}
.body {
  margin-top: 20px;
}
.footer {
  .top {
    display: flex;
    height: 60px;
    line-height: 60px;
  }
}
li {
  color: #555b65;
}
</style>
